// Program motivation section configuration
// Defines fields for participation reasons and expectations
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for program motivation section
export const programMotivationSectionSchema = z.object({
  whyParticipate: z.string().min(1, 'Este campo es requerido'),
  incubatorExpectations: z.string().min(1, 'Este campo es requerido'),
  growthAcceleration: z.string().min(1, 'Este campo es requerido'),
});

export type ProgramMotivationSectionData = z.infer<typeof programMotivationSectionSchema>;

// Section config
export const programMotivationSection: SectionConfig = {
  id: 'programMotivation',
  titleKey: 'Uso del programa / motivación',
  descriptionKey: 'Tu motivación para participar en el programa',
  validationSchema: programMotivationSectionSchema,
  fields: [
    {
      name: 'whyParticipate',
      type: 'textarea',
      label: '¿Por qué quieres participar en este programa?',
      placeholder: 'Explica tu motivación para participar...',
      required: true,
    },
    {
      name: 'incubatorExpectations',
      type: 'textarea',
      label: '¿Qué esperas obtener de la incubadora?',
      placeholder: 'Describe tus expectativas...',
      required: true,
    },
    {
      name: 'growthAcceleration',
      type: 'textarea',
      label: '¿Cómo este programa acelera tu crecimiento?',
      placeholder: 'Explica cómo el programa contribuirá a tu crecimiento...',
      required: true,
    },
  ],
};
